(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("4wWDB", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("1j7Ej")).then(function() {
    return parcelRequire("9nMib");
});

});
parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case "preload":
            return $86e02b94fb59de77$var$cachedPreloads;
        case "prefetch":
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("65QIS", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("eX4n6")).then(function() {
    return parcelRequire("Hk95u");
});

});

parcelRegister("9qrhj", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("5VZt9")).then(function() {
    return parcelRequire("6eJEm");
});

});

parcelRegister("fveK6", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("fBdXl")).then(function() {
    return parcelRequire("1scxX");
});

});

parcelRegister("kzC19", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3PuN6")).then(function() {
    return parcelRequire("hcPvc");
});

});

parcelRegister("8nu69", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("5zATY")).then(function() {
    return parcelRequire("8DRXn");
});

});

parcelRegister("dEMlq", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kXa26")).then(function() {
    return parcelRequire("llUFv");
});

});

parcelRegister("kzNMu", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("jCTON")).then(function() {
    return parcelRequire("jAMh3");
});

});

parcelRegister("Iu2Po", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("2BLIm"))((parcelRequire("fWbcT")).resolve("jtpZZ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2aPf0")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("10GuM"))
]).then(function() {
    return parcelRequire("82fsX");
});

});
parcelRegister("2BLIm", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRegister("6dveQ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("2BLIm"))((parcelRequire("fWbcT")).resolve("jtpZZ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2aPf0")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3sAZL"))
]).then(function() {
    return parcelRequire("jh5PX");
});

});

parcelRegister("2sc4p", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("2BLIm"))((parcelRequire("fWbcT")).resolve("jtpZZ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2aPf0")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("MBtzx"))
]).then(function() {
    return parcelRequire("5bv2G");
});

});

parcelRegister("98k9C", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("2BLIm"))((parcelRequire("fWbcT")).resolve("jtpZZ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("2aPf0")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("3BeXj"))
]).then(function() {
    return parcelRequire("23O9b");
});

});

parcelRegister("7Q6px", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("4AvOC")).then(function() {
    return parcelRequire("e5Q1B");
});

});

parcelRegister("gePYw", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("74z8D")).then(function() {
    return parcelRequire("1lZNa");
});

});

parcelRegister("4CR0G", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("62A6V")).then(function() {
    return parcelRequire("jO9Ma");
});

});

parcelRegister("6nDa0", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("bwKsO")).then(function() {
    return parcelRequire("6QiEN");
});

});

parcelRegister("9lMFq", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6EGzC")).then(function() {
    return parcelRequire("j4ybM");
});

});

var $6f7bad5210a29f8a$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL("2iNWU"), JSON.parse('["2iNWU","as-legacy.js","1j7Ej","eyeAble.c9f1ce4e.js","eX4n6","ccm19.e16c2dfc.js","5VZt9","dialogHandler.4d52db37.js","fBdXl","mainMenu.8c90472e.js","3PuN6","languageSelect.542b2a67.js","5zATY","submenu.f8960181.js","kXa26","accordion.d3a209bc.js","jCTON","defaultAccordion.892aa60c.js","10GuM","swiper.0955da95.js","2aPf0","swiper.92810e94.js","jtpZZ","swiper.47de45ed.css","3sAZL","certificateSwiper.e3171381.js","MBtzx","homeSwiper.1078a275.js","3BeXj","imageSwiper.bef9e9c2.js","4AvOC","popoverSelect.51f876c3.js","74z8D","asAddressSearch.f1f03cfe.js","62A6V","asBodyCompass.6b0c4133.js","bwKsO","eventCardClickHandler.2983ec11.js","6EGzC","sfEventMgt.ce761ce1.js"]'));

// ====================================================================================
// Main Entry Point - Prioritized Module Loading
// ====================================================================================
var $71e8dfd9d0b8fc28$export$d680cb6eec13a7c7 = function() {
    return new Promise(function(resolve) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
};
var $71e8dfd9d0b8fc28$export$be1257a3a9248b22 = function() {
    return new Promise(function(resolve) {
        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
            timeout: 1000
        });
        else setTimeout(resolve, 100);
    });
};


// =========================================================================
// CRITICAL: Cache selectors + load immediately (blocking)
// =========================================================================
var $765f16911476d698$var$contrastTrigger = document.querySelector(".btn--contrast");
var $765f16911476d698$var$hasCCM = document.querySelector("[data-ccm-loader-group]");
var $765f16911476d698$var$criticalImports = [];

if ($765f16911476d698$var$contrastTrigger) $765f16911476d698$var$criticalImports.push((parcelRequire("4wWDB")).then(function(m) {
    return m.init();
}));

if ($765f16911476d698$var$hasCCM) $765f16911476d698$var$criticalImports.push((parcelRequire("65QIS")).then(function(m) {
    return m.init();
}));
if ($765f16911476d698$var$criticalImports.length) Promise.all($765f16911476d698$var$criticalImports)["catch"](console.error);







// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
(0, $71e8dfd9d0b8fc28$export$d680cb6eec13a7c7)().then(function() {
    // Cache selectors
    var searchDialog = document.querySelector("#search-modal-dialog") || document.querySelector(".header-search-modal") || document.querySelector('[data-js="header-search"]');
    var burger = document.querySelector("#burger-modal-dialog") || document.querySelector(".burger-menu-modal") || document.querySelector('[data-js="burger-menu"]');
    var languageSelect = document.querySelector(".language-select-trigger");
    var submenuTrigger = document.querySelector(".open-submenu-button");
    var accordionTrigger = document.querySelector(".burger-menu__link-button") || document.querySelector("[data-js='as-accordion-details-item']");
    var defaultAccordionTrigger = document.querySelector("[data-js='accordion-item']");
    var mainMenu = document.querySelector(".main-menu--primary");
    var imports = [];
    if (searchDialog) imports.push((parcelRequire("9qrhj")).then(function(m) {
        return m.init("#search-modal-dialog", ".header-search-modal", '[data-js="header-search"]', '[data-js="header-search-modal-close"]', '[name="tx_solr[q]"]');
    }));
    if (burger) imports.push((parcelRequire("9qrhj")).then(function(m) {
        return m.init("#burger-modal-dialog", ".burger-menu-modal", ".btn--burger-2", '[data-js="burger-menu-modal-close"]');
    }));
    if (mainMenu) imports.push((parcelRequire("fveK6")).then(function(m) {
        return m.init();
    }));
    if (languageSelect) imports.push((parcelRequire("kzC19")).then(function(m) {
        return m.init();
    }));
    if (submenuTrigger) imports.push((parcelRequire("8nu69")).then(function(m) {
        return m.init(".open-submenu-button");
    }));
    if (accordionTrigger) imports.push((parcelRequire("dEMlq")).then(function(m) {
        return m.init();
    }));
    if (defaultAccordionTrigger) imports.push((parcelRequire("kzNMu")).then(function(m) {
        return m.init();
    }));
    if (imports.length) Promise.all(imports)["catch"](console.error);
});









// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
(0, $71e8dfd9d0b8fc28$export$be1257a3a9248b22)().then(function() {
    // Cache selectors
    var swiper = document.querySelector(".swiper-container");
    var certificateSwiper = document.querySelector(".certificate-swiper-container");
    var homeSwiper = document.querySelector(".home-swiper-container");
    var imageSwiper = document.querySelector(".image-swiper-container");
    var popoverSelect = document.querySelector('[data-component*="popover-select-trigger"]');
    var doctorFinder = document.querySelector(".doctor-finder.tx-as-address-search");
    var bodyCompass = document.querySelector(".ctype-ce_body_compass");
    var eventList = document.querySelector(".tx-sf-event-mgt");
    var eventSearchForm = document.getElementById("searchDemand");
    var imports = [];
    if (swiper) imports.push((parcelRequire("Iu2Po")).then(function(m) {
        return m.init();
    }));
    if (certificateSwiper) imports.push((parcelRequire("6dveQ")).then(function(m) {
        return m.init();
    }));
    if (homeSwiper) imports.push((parcelRequire("2sc4p")).then(function(m) {
        return m.init();
    }));
    if (imageSwiper) imports.push((parcelRequire("98k9C")).then(function(m) {
        return m.init();
    }));
    if (popoverSelect) imports.push((parcelRequire("7Q6px")).then(function(m) {
        return m.init();
    }));
    if (doctorFinder) imports.push((parcelRequire("gePYw")).then(function(m) {
        return m.init();
    }));
    if (bodyCompass) imports.push((parcelRequire("4CR0G")).then(function(m) {
        return m.init();
    }));
    if (eventList) imports.push((parcelRequire("6nDa0")).then(function(m) {
        return m.init();
    }));
    if (eventSearchForm) imports.push((parcelRequire("9lMFq")).then(function(m) {
        return m.init();
    }));
    if (imports.length) Promise.all(imports)["catch"](console.error);
});

})();
//# sourceMappingURL=as-legacy.js.map
